module.exports = __webpack_public_path__ + "static/media/Validation4.a08683a3.png";